/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import {
	Text,
	Box,
	Button,
	Flex,
	Input,
	WrapItem,
	AlertDialog,
	AlertDialogOverlay,
	AlertDialogContent,
	AlertDialogHeader,
	AlertDialogBody,
	AlertDialogFooter,
} from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { v4 as uuidv4 } from 'uuid';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMinusSquare } from '@fortawesome/free-solid-svg-icons';
import LabelDetail from '../../../../components/LabelDetail';
import DownloadAndViewButton from '../../../../components/Files/DownloadAndViewButton';
import TempFileUploader from '../../../../components/Files/TempFileUploader';

function AdditionalAttachment({ initData = [], isEditing = false, onChange = () => null, showLabel = true }) {
	const { t } = useTranslation();
	const [list, setList] = useState(initData || []);
	const [uploadingFile, setUploadingFile] = useState(false);
	const [removingId, setRemovingId] = useState(null);

	useEffect(() => setList(initData), [initData]);

	function addNewFile() {
		const tempFiles = [
			...list,
			{
				no: list?.length === 0 ? 1 : list[list?.length - 1]?.no + 1,
				id: uuidv4(),
				label: '',
				tempFile: '',
				file: '',
			},
		];
		setList(tempFiles);
		onChange(tempFiles);
	}

	function removeFile(id) {
		let tempRes = [];
		list?.forEach((item) => {
			if (id !== item?.id) {
				tempRes.push(item);
			}
		});
		setList(tempRes);
		onChange(tempRes);
	}

	function onLabelChange(id, label) {
		let tempRes = [];
		list?.forEach((item) => {
			if (id === item?.id) {
				tempRes.push({
					...item,
					label,
				});
			} else {
				tempRes.push(item);
			}
		});
		setList(tempRes);
		onChange(tempRes);
	}

	function onFileChange(id, fileId) {
		let tempRes = [];
		list?.forEach((item) => {
			if (id === item?.id) {
				tempRes.push({
					...item,
					tempFile: fileId,
				});
			} else {
				tempRes.push(item);
			}
		});
		setList(tempRes);
		onChange(tempRes);
	}

	function onRemoveFile(id) {
		let tempRes = [];
		list?.forEach((item) => {
			if (id === item?.id) {
				tempRes.push({
					...item,
					tempFile: '',
					file: '',
				});
			} else {
				tempRes.push(item);
			}
		});
		setList(tempRes);
		onChange(tempRes);
	}

	function removeUploadedFile(id) {
		let tempRes = [];
		list?.forEach((item) => {
			if (id === item?.id) {
				tempRes.push({
					...item,
					file: '',
					tempFile: '',
				});
			} else {
				tempRes.push(item);
			}
		});
		setList(tempRes);
		onChange(tempRes);
	}

	function itemInput(item) {
		return (
			<Flex w="100%" key={item?.id} mb={2} justifyContent="flex-start" alignItems="center">
				<Flex flex="1" flexDirection="column" justifyContent="center">
					{showLabel && <Text fontWeight="bold">{t('Label')}</Text>}
					<Input mt="1" size="sm" value={item?.label} onChange={(e) => onLabelChange(item?.id, e?.currentTarget.value)} />
				</Flex>
				<Flex ml="4" flex="1" flexDirection="column" justifyContent="center">
					{showLabel && <Text fontWeight="bold">{t('File')}</Text>}
					{item?.file?.url ? (
						<Box ml="-4">
							<WrapItem className="avatarWraper">
								<FontAwesomeIcon
									onClick={() => {
										removeUploadedFile(item?.id);
									}}
									className="remove"
									icon={faMinusSquare}
									style={{
										fontSize: 18,
										display: 'none',
										position: 'absolute',
										zIndex: '100',
										marginLeft: 16,
										color: 'red',
										backgroundColor: 'white',
										padding: 2,
										cursor: 'pointer',
									}}
								/>
								<DownloadAndViewButton url={item?.file?.url} size={item?.file?.size} />
							</WrapItem>
						</Box>
					) : (
						<TempFileUploader
							callBack={(e) => onFileChange(item?.id, e?.id)}
							label={null}
							required={true}
							onCancelFile={() => onRemoveFile(item?.id)}
							callBackUploading={(e) => setUploadingFile(e)}
							disabled={uploadingFile}
							mt={0}
							mb={0}
							size="sm"
						/>
					)}
				</Flex>
				<Flex ml="4" flexDirection="column" justifyContent="center">
					{showLabel && <Text fontWeight="bold">&nbsp;</Text>}
					<Button
						onMouseDown={() => {
							if (item?.tempFile || item?.label || item?.file?.url) {
								setRemovingId(item?.id);
							} else {
								removeFile(item?.id);
							}
						}}
						colorScheme="blue"
						variant="outline"
						size="sm"
						ml="4"
					>
						{t('Remove')}
					</Button>
				</Flex>
			</Flex>
		);
	}

	return (
		<>
			{isEditing ? (
				<Box>
					{showLabel && (
						<Box mt="6">
							<Text mt="4" fontSize="lg" mb="2" fontWeight="bold">
								{t('Other Attachments')}
							</Text>
						</Box>
					)}
					{list.map((item) => {
						return itemInput(item);
					})}
					<Button onMouseDown={() => addNewFile()} colorScheme="blue" variant="outline" size="sm">
						{t('Add other attachments')}
					</Button>
				</Box>
			) : (
				<>
					{list?.length > 0 && (
						<Box>
							{showLabel && (
								<Box mt="6">
									<Text mt="4" fontSize="lg" mb="2" fontWeight="bold">
										{t('Other Attachments')}
									</Text>
								</Box>
							)}
							{list?.map((item, i) => {
								return (
									<LabelDetail
										key={i}
										responsive={true}
										mb={2}
										mt={0}
										labelWidth="250px"
										direction="row"
										label={item?.label}
										childDetail={item?.file?.url ? <DownloadAndViewButton url={item?.file?.url} size={item?.file?.size} /> : 'N/A'}
									/>
								);
							})}
						</Box>
					)}
				</>
			)}
			<AlertDialog isOpen={removingId ? true : false} onClose={() => setRemovingId(null)}>
				<AlertDialogOverlay>
					<AlertDialogContent>
						<AlertDialogHeader fontSize="lg" fontWeight="bold">
							{t('Remove')}
						</AlertDialogHeader>
						<AlertDialogBody>{t('Are you sure to remove other attachments?')}</AlertDialogBody>
						<AlertDialogFooter>
							<Button mr={4} onClick={() => setRemovingId(null)}>
								{t('No')}
							</Button>
							<Button
								colorScheme="red"
								onClick={() => {
									setRemovingId(null);
									removeFile(removingId);
								}}
							>
								{t('Yes')}
							</Button>
						</AlertDialogFooter>
					</AlertDialogContent>
				</AlertDialogOverlay>
			</AlertDialog>
		</>
	);
}

export default AdditionalAttachment;
